import Model from "../Model";

class KpiGraphsComercialClientZone2 extends Model{

    buildUrl ({ param }) {
        return ['kpizoneclientview/infobyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiGraphsComercialClientZone2;